import { skipToken, useQuery } from '@tanstack/react-query';
import { useApiClient } from '../contexts/ApiContext';
import { queryKeys } from '../lib/queryClient';
import { ModeEnum } from '../services/generated/Api';

const HISTORY_PAGE_SIZE = 30;

export function useRushMidHistory(enabled = true) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: queryKeys.rushMidHistory,
    queryFn: () => apiClient.api.rushMidControllerHistory({ take: HISTORY_PAGE_SIZE }),
    enabled,
    refetchOnMount: 'always',
  });
}

export type RushMidRatingMode = 1 | 2 | 5;

const MODE_ENUM: Record<RushMidRatingMode, ModeEnum> = {
  1: ModeEnum.Value1,
  2: ModeEnum.Value2,
  5: ModeEnum.Value5,
};

export function useRushMidRating(mode: RushMidRatingMode, enabled = true) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: queryKeys.rushMidRating(mode),
    queryFn: () => apiClient.api.rushMidControllerRating({ mode: MODE_ENUM[mode] }),
    enabled,
    refetchOnMount: 'always',
  });
}

export function useRushMidSkins(enabled = true) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: queryKeys.rushMidSkins,
    queryFn: () => apiClient.api.rushMidControllerGetSkins(),
    enabled,
  });
}

export function useRushMidMatchDetail(matchId: string | null) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['rushMid', 'match', matchId] as const,
    queryFn: matchId ? () => apiClient.api.rushMidControllerMatchDetail(matchId) : skipToken,
  });
}

export function useRushMidReplay(matchId: string | null) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['rushMid', 'replay', matchId] as const,
    queryFn: matchId ? () => apiClient.api.rushMidControllerReplay(matchId) : skipToken,
  });
}
